export default "__VITE_ASSET__6616613f__"